import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import LinearProgress from "@mui/material/LinearProgress";
import Alert from "@mui/material/Alert";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import Paper from "@mui/material/Paper";
import { useSiteVerifications } from "./useSiteVerifications";
import { Header } from "./Header";
import { VerificationRow } from "./VerificationRow";
import type { JSX } from "react";

export function SiteVerifications() {
  let siteVerifications: JSX.Element;
  const navigate = useNavigate();
  const { state, fetching, page, pageSize, setPage, setPageSize, refetch } = useSiteVerifications();
  // MUI считает страницы с нуля, экран — с единицы.
  const zeroBasedPage = page - 1;

  if (state.kind === "loading") {
    siteVerifications = (
      <Box p={3}>
        <Header onBack={() => {
      void navigate("/sites");
    }} />
        <Box display="flex" justifyContent="center" p={6}>
          <CircularProgress />
        </Box>
      </Box>
    );
  } else {
    if (state.kind === "error") {
      siteVerifications = (
      <Box p={3}>
        <Header onBack={() => {
      void navigate("/sites");
    }} />
        <Alert severity="error" action={<Button size="small" onClick={refetch}>Повторить</Button>}>
          Ошибка загрузки: {state.message}
        </Alert>
      </Box>
    );
    } else {
      siteVerifications = (
    <Box p={3}>
      <Header onBack={() => {
      void navigate("/sites");
    }} />

      {fetching && <LinearProgress sx={{ mb: 1 }} />}

      {state.kind === "empty" ? (
        <Box textAlign="center" py={4}>
          <Typography color="text.secondary">Ещё ни одной проверки доступов не запускалось</Typography>
        </Box>
      ) : (
        <>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Дата запуска</TableCell>
                  <TableCell>Статус</TableCell>
                  <TableCell align="right">Прогресс</TableCell>
                  <TableCell align="right">Article валидных</TableCell>
                  <TableCell align="right">Article невалидных</TableCell>
                  <TableCell align="right">Homepage валидных</TableCell>
                  <TableCell align="right">Homepage невалидных</TableCell>
                  <TableCell align="right">Sitewide валидных</TableCell>
                  <TableCell align="right">Sitewide невалидных</TableCell>
                  <TableCell align="right">Link-removal валидных</TableCell>
                  <TableCell align="right">Link-removal невалидных</TableCell>
                  <TableCell>Ошибки</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {state.items.map((item) => (
                  <VerificationRow key={item.id} item={item} />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component="div"
            count={state.totalCount}
            page={zeroBasedPage}
            onPageChange={(_event, newPage) => setPage(newPage + 1)}
            rowsPerPage={pageSize}
            onRowsPerPageChange={(event) => setPageSize(Number(event.target.value))}
            rowsPerPageOptions={[10, 25, 50]}
            labelRowsPerPage="На странице:"
            labelDisplayedRows={({ from, to, count }) => `${from}–${to} из ${count}`}
          />
        </>
      )}
    </Box>
  );
    }
  }
  return siteVerifications;
}
